import React, { useState, useEffect } from "react";
import HTMLFlipBook from "react-pageflip";
import "./styles.css";
import flipSound from './page-flip.mp3';

const FlipBook = () => {
  const [pageImages, setPageImages] = useState([]);
  const audio = new Audio(flipSound);

  // 🔊 Smooth sound play
  const handleFlip = () => {
    audio.currentTime = 0;
    audio.play();
  };

  // 📥 Load all images dynamically
  useEffect(() => {
    const totalPages = 14; // <-- SET YOUR PAGE COUNT HERE
    const imgs = [];

    for (let i = 1; i <= totalPages; i++) {
      imgs.push(`/pages/${i}.jpg`);
    }

    setPageImages(imgs);
  }, []);

  // 📏 Responsive book size
  const getBookSize = () => {
    const width = window.innerWidth;

    if (width < 480) {
      return { bookWidth: 350, bookHeight: 500 };
    } else if (width < 768) {
      return { bookWidth: 420, bookHeight: 580 };
    } else {
      return { bookWidth: 480, bookHeight: 650 };
    }
  };

  const { bookWidth, bookHeight } = getBookSize();

  return (
    <div className="h-screen flex justify-center items-center overflow-hidden">

      {pageImages.length > 0 && (
        <HTMLFlipBook
          width={bookWidth}
          height={bookHeight}
          showCover={true}
          onFlip={handleFlip}
          maxShadowOpacity={0.2}
        >
          {pageImages.map((src, index) => (
            <div className="page" key={index}>
              <img
                src={src}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover"
                }}
                alt={`page-${index + 1}`}
              />
            </div>
          ))}
        </HTMLFlipBook>
      )}
    </div>
  );
};

export default FlipBook;
